/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { IUser } from '../shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { MessageService } from 'primeng/api';
import { AppUtils } from 'common/services/app.util';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { AuthService } from 'common/services/auth.service';

@Component({
  selector: 'app-loginAdmin',
  templateUrl: './app.loginAdmin.component.html',
  styleUrls: ['./app.loginAdmin.component.css']
})
export class AppLoginAdminComponent {
  @ViewChild('recaptcha', { static: true }) recaptchaElement: ElementRef;
  user: IUser;
  passwordType: string = "password";
  loading: boolean;
  tokenTimer: NodeJS.Timer;
  errorMessage: string = '';
  gymId: string = '';
  error: boolean = false;
  response: any;
  isDisableSignin: boolean = true;
  isCaptchaShow = false;

  constructor(
    private LanguageService: LanguageService,
    private appServicemanager: AppServiceManager,
    private route: Router,
    private messageService: MessageService
  ) {
    const currentUrl = window.location.href;
    console.log(currentUrl); // Output: "http://localhost:4200/#/loginAdmin"

    // if (currentUrl.includes('124.109.41.119:9090') || currentUrl.includes('192.168.100.204:6060')) {
    //   // production
    //   this.isCaptchaShow = true;
    // }
    // else {
    //   // staging
    //   this.isCaptchaShow = false;
    // }

  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("AppLoginAdminComponent", label);
  }
  ngOnInit() {
    this.user = new IUser();
    this.addRecaptchaScript();
    this.gymId = "";
  }
  togglePasswordType() {
    if (this.passwordType === "password") {
      this.passwordType = "text";
    } else {
      this.passwordType = "password";
    }
  }

  /**
   * Gets the first available route from user privileges
   * @param privileges Array of privilege objects
   * @returns The first available route path or null
   */
  private getFirstAvailableRoute(privileges: any[]): string | null {
    if (!privileges || privileges.length === 0) {
      return null;
    }

    // Map pageType to route (similar to menu component logic)
    for (const permission of privileges) {
      if (permission.pageType === "Dashboard") {
        return "/dashboard";
      }
      if (permission.pageType === "Member Management") {
        return "/members";
      }
      if (permission.pageType === "Activity Logs") {
        return "/activity-logs";
      }
      if (permission.pageType === "Setting" && permission.pageName === "User Management") {
        return "/settings";
      }
      if (permission.pageType === "Inactive Members") {
        return "/members/inactive";
      }
      if (permission.pageType === "Notifications Management" && permission.pageName === "Notifications") {
        return "/notifications";
      }
      if (permission.pageType === "Enquiry Management") {
        return "/enquiry-listing";
      }
      if (permission.pageType === "Visitors Management") {
        return "/visitors";
      }
      if (permission.pageType === "Requests Management") {
        return "/requests-management";
      }
      if (permission.pageType === "Member Requests") {
        return "/member-requests";
      }
      if (permission.pageType === "Fees Approval") {
        return "/feesApproval";
      }
      if (permission.pageType === "Asset Management") {
        return "/assets-management";
      }
      if (permission.pageType === "Account Management") {
        return "/accounts";
      }
      if (permission.pageType === "Attendance") {
        return "/attendance";
      }
      if (permission.pageType === "Package Builder") {
        return "/package-Builders";
      }
      if (permission.pageType === "Training Sessions") {
        return "/training-sessions";
      }
      if (permission.pageType === "Session Attendance") {
        return "/session-attendance";
      }
      if (permission.pageType === "Self Sessions") {
        return "/self-sessions";
      }
      if (permission.pageType === "Trainer Dashboard") {
        return "/trainer-dashboard";
      }
      if (permission.pageType === "Locked List") {
        return "/locked-listing";
      }
      if (permission.pageType === "Petty Cash") {
        return "/petty-cash";
      }
      if (permission.pageType === "Slots Management" && permission.pageName === "Bookings") {
        return "/bookings";
      }
      if (permission.pageType === "Slots Management" && permission.pageName === "Booking Slots") {
        return "/slots";
      }
      if (permission.pageType === "Products" && permission.pageName === "Products Listing") {
        return "/products-listing";
      }
      if (permission.pageType === "Purchasing" && permission.pageName === "Suppliers") {
        return "/suppliers-listing";
      }
      if (permission.pageType === "Sales" && permission.pageName === "Point of Sales") {
        return "/point-of-sale";
      }
      // For Reports and other pageTypes that use pageUrl
      if (permission.pageType === "Reports" && permission.pageName === "User Attendance") {
        return "/user-attendance";
      }
      if (permission.pageUrl) {
        // For reports, check if it's a report type
        if (permission.pageType === "Reports") {
          return '/reports/' + permission.pageUrl;
        }
        // If pageUrl starts with /, use it directly, otherwise prepend /
        const route = permission.pageUrl.startsWith('/') ? permission.pageUrl : '/' + permission.pageUrl;
        return route;
      }
    }

    return null;
  }

  private showLoginError(error: unknown, fallback: string): void {
    const detail = AppUtils.getHttpErrorMessage(error, fallback);

    if (AppUtils.isLicenceError(detail)) {
      this.error = true;
      this.errorMessage = detail + '!!' + '<br />' + ' Contact Us' + '<br />' + 'Email: rashid_562@hotmail.com'
        + '<br />' + ' Contact No: 923335478182';
      this.messageService.clear();
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail });
      return;
    }

    this.error = false;
    this.errorMessage = '';
    this.messageService.clear();
    this.messageService.add({ severity: 'error', summary: 'Error Message', detail });
  }

  login() {
    this.loading = true;
    var dataSent = {
      email: this.user.email,
      password: this.user.password,
      gymId: this.gymId
    }
    this.appServicemanager.post('auth/actions/authenticate-admin', dataSent).subscribe((res: any) => {
      if (res.error === null) {
        this.user = res.data.user;
        this.user.branch = this.gymId;
        this.user.company = res.data.company[0]._id;
        localStorage.setItem('currentUser', JSON.stringify(this.user));
        localStorage.setItem('currentRole', JSON.stringify(res.data.role));
        localStorage.setItem('currentCompany', JSON.stringify(res.data.company[0]));

        // calling img paths
        const appUtils = new AppUtils();
        appUtils.setImagesPath(this.user.company, this.user.branch);

        setTimeout(function () {
          // Code to be executed after the delay
          // This block of code will be executed after 1 second (1000 milliseconds)
        }, 1000);
        const token = res.data.token;
        const expiresInDuration = res.data.expiresIn;
        this.setAuthTimer(expiresInDuration);
        const now = new Date();
        const expirationDate = new Date(now.getTime() + expiresInDuration * 1000);
        this.saveAuthData(token, expirationDate);

        // Get the first available route from privileges
        const firstRoute = this.getFirstAvailableRoute(res.data.role.privileges);
        const defaultRoute = firstRoute || "members";
        this.route.navigateByUrl(defaultRoute);
      } else {
        this.showLoginError(res, 'Login failed. Please check your credentials and try again.');
      }
      this.loading = false;
    },
      (error) => {
        this.showLoginError(error, 'Login failed. Please check your credentials and try again.');
        this.loading = false;
      });
  }

  addRecaptchaScript() {
    window['grecaptchaCallback'] = () => {
      this.renderReCaptcha();
    }
    (function (d, s, id, obj) {
      var js, fjs = d.getElementsByTagName(s)[0];
      js = d.createElement(s); js.id = id;
      js.src = "https://www.google.com/recaptcha/api.js?onload=grecaptchaCallback&render=explicit";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'recaptcha-jssdk', this));

  }

  renderReCaptcha() {
    window['grecaptcha'].render(this.recaptchaElement.nativeElement, {
      'sitekey': '6LeBcNofAAAAALKEmqYmmxrDJ7Fi9IpwDAPMVCtm',
      'expired-callback': () => {
        this.isDisableSignin = true;
        document.getElementById('gymId').focus();
      },
      'callback': (response) => {
        console.log(response);
        this.response = response;
        if (response == "") {
          this.isDisableSignin = true;
        } else {
          this.isDisableSignin = false;
          document.getElementById('gymId').focus();
        }
      }
    });
  }

  // verifyReCaptcha() {
  //   this.loading = true;
  //   let data = {
  //     token: this.response
  //   }
  //   this.appServicemanager.post('branches/' + AuthService.getLoggedInBranch() + '/users/actions/validate-recaptcha', data).subscribe((res: any) => {
  //     if (res.success) {
  //       this.login();
  //     } else {
  //       this.messageService.clear();
  //       this.messageService.add({ severity: 'error', summary: 'Error Message', detail: res.error });
  //     }
  //   },
  //     (error) => {
  //   });
  // }

  verifyReCaptcha() {
    this.loading = true;
    let data = {
      token: this.response
    }
    this.appServicemanager.post('branches/' + AuthService.getLoggedInBranch() + '/users/actions/validate-recaptcha', data).subscribe((res: any) => {
      if (res.success) {
        this.login();
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'reCAPTCHA failed' });
        this.loading = false;
        setTimeout(() => {
          window.location.reload();

        }, 2000);
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        this.loading = false;
        setTimeout(() => {
          window.location.reload();

        }, 2000);
      });
  }

  logout() {
    this.clearAuthData();
    clearTimeout(this.tokenTimer as unknown as number);
    this.route.navigateByUrl('/login');
  }

  private setAuthTimer(duration: number) {
    console.log("Setting timer: " + duration);
    // this.tokenTimer = setTimeout(() => {
    //   this.logout();
    // }, duration * 1000);
  }

  private saveAuthData(token: string, expirationDate: Date) {
    localStorage.setItem('token', JSON.stringify(token));
    localStorage.setItem('expiration', JSON.stringify(expirationDate.toISOString()));
  }

  private clearAuthData() {
    localStorage.removeItem('currentUser');
    localStorage.removeItem('currentRole');
    localStorage.removeItem('token');
    localStorage.removeItem('expiration');
    localStorage.removeItem('currentCompany');
  }

}
